export class Formacao {
    constructor({
      id = null,
      abaPlanoTrabalho = Array(),
      abaProgramacao = Array(),
      abaOrcamento = Array(),
      ativas = null,
      questoes = Array(),
      avaliacaoId = null
    }) {
        this.id = id;
        this.abaPlanoTrabalho = abaPlanoTrabalho;
        this.abaProgramacao = abaProgramacao;
        this.abaOrcamento = abaOrcamento;
        this.ativas = ativas;
        this.questoes = questoes;
        this.avaliacaoId = avaliacaoId;
    }
  
    static Build() {
      return new Formacao({
        id: null,
        abaPlanoTrabalho: Array(),
        abaProgramacao: Array(),
        abaOrcamento: Array(),
        questoes: Array(),
        ativas: null,
        avaliacaoId: null
      });
    }
}
